@if (tableController()) {
  <app-search-form
    [formGroup]="tableController().searchForm"
    (searchClicked)="tableController().onSearch()"
  >
    <div class="search-fields">
      <app-select-user
        formControlName="createdByUserId"
        appearance="outline"
        label="Créé par"
        [userRoles]="realmRoles"
      ></app-select-user>
      <mat-form-field appearance="outline">
        <mat-label>Nom employé</mat-label>
        <input matInput formControlName="employeeLastname" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Prénom employé</mat-label>
        <input matInput formControlName="employeeFirstname" />
      </mat-form-field>

      <app-select-company
        formControlName="companyId"
        appearance="outline"
        [nullable]="true"
      ></app-select-company>
      <app-multi-select-contract-status
        appearance="outline"
        label="Statut"
        formControlName="statuses"
      ></app-multi-select-contract-status>
      <app-select-user
        formControlName="pendingValidationRequestRequestedToUserId"
        appearance="outline"
        label="Validation en attente de"
        [userRoles]="realmRoles"
      ></app-select-user>
      <mat-form-field appearance="outline">
        <mat-label>Avenant</mat-label>
        <mat-select formControlName="amendmentInProgress">
          <mat-option [value]="null">Tous les contrats</mat-option>
          <mat-option [value]="true">Avenant en cours</mat-option>
          <mat-option [value]="false">Sans avenant en cours</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-slide-toggle formControlName="deleted">Contrats supprimés</mat-slide-toggle>
    </div>
  </app-search-form>
}
